// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","margin":"calc(var(--ring-unit)*4)","button":"ShowAllBuildTypes__button--AO"};